import React from 'react';

type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  fillColor?: string;
};

export const BackgroundAlignIcon = (props: Props) => {
  const {
    width = '24',
    height = '12',
    viewBox = '0 0 24 12',
    fillColor = 'var(--background)',
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" width="23" height="5" rx="1" fill={fillColor} />
      <rect x="0.5" y="7" width="23" height="5" rx="1" fill={fillColor} />
    </svg>
  );
};

export const BackgroundAlignIconAlt = (props: Props) => {
  const {
    width = '24',
    height = '12',
    viewBox = '0 0 24 12',
    fillColor = '#848484',
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" width="23" height="5" rx="1" fill={fillColor} />
      <rect x="5" y="7" width="14" height="5" rx="1" fill={fillColor} />
    </svg>
  );
};
